<template>
    <div class="course_detail">
        <div class="course_detail_item">
            <div class="course_detail_left">
                <img src="../assets/jiaozi.jpg">
            </div>
            <div class="course_detail_center">
                <div class="course_detail_center_title">教师资格证</div>
                <div class="course_detail_center_detail">教师资格证是教育行业从业教师的许可证。</div>
            </div>
            <div class="course_detail_more">
                <Button icon="md-arrow-dropright-circle">
                    <router-link to="/article/jszgz">查看更多</router-link>
                </Button>
            </div>
        </div>
        <div class="course_detail_item">
            <div class="course_detail_left">
                <img src="../assets/computer.jpg">
            </div>
            <div class="course_detail_center">
                <div class="course_detail_center_title">计算机二级</div>
                <div class="course_detail_center_detail">计算机二级考试是全国计算机等级考试</div>
            </div>
            <div class="course_detail_more">
                <Button icon="md-arrow-dropright-circle">
                    <router-link to="/article/jsjej">查看更多</router-link>
                </Button>
            </div>
        </div>
        <div class="course_detail_item">
            <div class="course_detail_left">
                <img src="../assets/kuaiji.jpg">
            </div>
            <div class="course_detail_center">
                <div class="course_detail_center_title">会计初级</div>
                <div class="course_detail_center_detail">从事会计工作的资格证书</div>
            </div>
            <div class="course_detail_more">
                <Button icon="md-arrow-dropright-circle">
                    <router-link to="/article/kjz">查看更多</router-link>
                </Button>
            </div>
        </div>
        <div class="course_detail_item">
            <div class="course_detail_left">
                <img src="../assets/jiaobian.jpg">
            </div>
            <div class="course_detail_center">
                <div class="course_detail_center_title">银行证券</div>
                <div class="course_detail_center_detail">证券资格是进入证券行业的必备证书</div>
            </div>
            <div class="course_detail_more">
                <Button icon="md-arrow-dropright-circle">
                    <router-link to="/article/yhzqz">查看更多</router-link>
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style>
.course_detail_item {
  margin: 20px 0;
  align-items: center;
  padding: 20px;
  border: 1px solid #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.course_detail_left {
  flex: 1.5;
}
.course_detail_left img {
  width: 100%;
}
.course_detail_center {
  display: flex;
  flex-direction: column;
  padding: 20px;
  flex: 3;
}
.course_detail_center_title {
  color: white;
  font-size: 25px;
  font-weight: bold;
  letter-spacing: 5px;
}
.course_detail_center_detail {
  font-size: 20px;
  color: whitesmoke;
  letter-spacing: 2px;
}
.course_detail_more {
  flex: 0.5;
}
</style>
